
// export const myGetter = ( input ) => {
//  return input
// }

export const inputsList = state => state.inputs
export const inputsPaginatedData = state => state.inputsPaginatedData
export const input = state => state.input
export const isLoading = state => state.isLoading